<template>
	<div class="input-date">
		<input
			type="text"
			ref="input"
			@input="inputHandler"
			@keydown="keydownHandler"
			@click.self="clickHandler"
			@blur="blurHandler"
		/>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},

		methods: {
			blurHandler(event) {
				this.maskInput(event)
			},

			inputHandler(event) {
				this.maskInput(event)
			},

			clickHandler(event) {
				let el = event.target
				let start = el.selectionStart
				let value = event.target.value.toString().replace(/\D/g, '')

				this.$nextTick(() => {
					if (start >= 0 && start <= 2) {
						el.setSelectionRange(0, 2)
					} else if (start >= 3 && start <= 5) {
						el.setSelectionRange(3, 5)
					} else if (start >= 6 && start <= 10) {
						el.setSelectionRange(6, 10)
					} else {
						el.setSelectionRange(0, value.length)
					}
				})
			},

			/**
			 * Limitar as teclas que podem ser usadas
			 * Permite as teclas dos números
			 * Permite as teclas $keys
			 * Permite copiar e colar com ctrl/cmd
			 */
			keydownHandler(event) {
				const { key, keyCode, ctrlKey } = event
				const keys = [
					'Backspace',
					'Tab',
					'Esc',
					'Escape',
					'Enter',
					'Home',
					'End',
					'PageUp',
					'PageDown',
					'Del',
					'Delete',
					'Left',
					'ArrowLeft',
					'Right',
					'ArrowRight',
					'Insert',
					'Up',
					'ArrowUp',
					'Down',
					'ArrowDown',
				]
				if (
					!(
						(key >= '0' && key <= '9') ||
						keys.includes(key) ||
						(ctrlKey && [65, 67, 86, 88].includes(keyCode))
					)
				) {
					event.preventDefault()
				}
			},

			/**
			 * Aplica a mascara ao valor do input
			 * Define os limites nos valores de dias, meses e anos
			 * 
			 */
			maskInput(event) {
				let date = []
				let result = null
				// eslint-disable-next-line
				let cursorStart = event.target.selectionStart
				let value = event.target.value.toString().replace(/\D/g, '')

				// Define um array em fomato de DATA para
				// validar separadamente os valores
				date[0] = value.substring(0, 2)
				date[1] = value.substring(2, 4)
				date[2] = value.substring(4, 8)

				this.$nextTick(() => {
					// Limita a quantidade de caracteres
					if (value.length > 8) return (event.target.value = event.target.value.toString().substring(0, 10))

					// Limita a quantidade de caracteres para o dia
					if (date[0].length > 2) date[0] = date[0].substring(0, 2)

					// Limita a quantidade de caracteres para o mês
					if (date[1].length > 2) date[1] = date[1].substring(0, 2)

					// Limita a quantidade de caracteres para o ano
					if (date[2].length > 4) date[2] = date[2].substring(0, 4)
				})

				this.$nextTick(() => {
					if (value.length == 8) {
						// Define o máximo de dias para 31
						if (Number(date[0]) > 31) date[0] = 31

						// Define o máximo de meses para 12
						if (Number(date[1]) > 12) date[1] = 12

						// Define o máximo de meses para 2200
						if (Number(date[2]) > 2200) date[2] = 2200

						// Define o minimo de dias para 01
						if (date[0].length == 2 && date[0] < 1) date[0] = '01'

						// Define o minimo de meses para 01
						if (date[1].length == 2 && date[1] < 1) date[1] = '01'

						// Define o minimo de anos para 1900
						if (date[2].length == 4 && date[2] < 1900) date[2] = '1900'
					}
				})

				this.$nextTick(() => {
					result = '' + date[0] + date[1] + date[2]
				})

				this.$nextTick(() => {
					// Adiciona a Mascara
					if (value.length == 1) {
						result = result.replace(/^(\d{1}).*/, '$1')
					} else if (value.length === 2) {
						result = result.replace(/^(\d{2}).*/, '$1')
					} else if (value.length === 3) {
						result = result.replace(/^(\d{2})(\d{1}).*/, '$1/$2')
					} else if (value.length === 4) {
						result = result.replace(/^(\d{2})(\d{2}).*/, '$1/$2')
					} else if (value.length === 5) {
						result = result.replace(/^(\d{2})(\d{2})(\d{1}).*/, '$1/$2/$3')
					} else if (value.length === 6) {
						result = result.replace(/^(\d{2})(\d{2})(\d{2}).*/, '$1/$2/$3')
					} else if (value.length === 7) {
						result = result.replace(/^(\d{2})(\d{2})(\d{3}).*/, '$1/$2/$3')
					} else {
						result = result.replace(/^(\d{2})(\d{2})(\d{4}).*/, '$1/$2/$3')
					}
				})

				this.$nextTick(() => {
					// Seta/Imprime o valor no input
					event.target.value = result
				})

				if (cursorStart < value.length || event.inputType === 'deleteContentBackward') {
					this.$nextTick(() => {
						// Posiciona o cursor na posição correta (atual/ultima)
						this.$refs.input.selectionEnd = cursorStart
						this.$refs.input.selectionStart = cursorStart
					})
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>